import { get } from '../../lib/api/client';

/**
 * Dish (listing) detail — `GET /admin/listings/{id}/detail`
 * (api-core-go `admin-order-listing.go`). A "dish" in the admin UI is a
 * Listing plus its Dish row.
 */

export interface PersonRef {
  profileId: string;
  displayName: string;
}

/** `model.Address`. */
export interface AddressShape {
  address?: string;
  street1?: string;
  street2?: string;
  city?: string;
  stateProvince?: string;
  postalCode?: string;
  country?: string;
}

/** `model.Listing` fields the dialog shows. Money in cents. */
export interface Listing {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: string;
  title: string;
  description?: string;
  quantity?: number;
  price?: number;
  listerId: string;
  postalCode?: string;
  stateProvince?: string;
  imageUrl?: string;
  thumbnailUrl?: string;
  timeWindow?: Record<string, unknown>;
  listingLocation?: AddressShape;
  obfuscatedLocation?: string;
  localeId?: string;
  cancellationReason?: string;
  publishedAt?: string;
  autoReadyEnabled: boolean;
  authoredLang: string;
  shareConnectionLevel: number;
}

/** `model.Dish`. */
export interface Dish {
  id: string;
  status: string;
  fulfillmentMethod: string[] | null;
  dietaryTags?: string[] | null;
  allergenTags?: string[] | null;
  originTags?: string[] | null;
  ingredients?: Record<string, unknown>;
}

export interface ListingDetail {
  listing: Listing;
  dish: Dish | null;
  chef: PersonRef | null;
  /** Completed orders only. */
  stats: { ordersPlaced: number; portionsSold: number };
}

export async function getListingDetail(id: string, signal?: AbortSignal): Promise<ListingDetail> {
  return get<ListingDetail>(`/admin/listings/${encodeURIComponent(id)}/detail`, undefined, signal);
}
